import { eventListener } from "../managers/EventListener";
import { musicManager } from "../managers/MusicManager";
import { wasJump } from "../logic/JumpLogic";
import { wasSitup } from "../logic/SitupLogic";
import { useEffect, useState } from "react";
import situpUp from "../assets/s-up.png"
import situpDown from "../assets/s-down.png"
import jumpUp from "../assets/j-up.png"
import jumpDown from "../assets/j-down.png"

const PLAYTIME = 60000 //n sec * 1000

const prepStage0 = (setStage) => {
  eventListener.clearMethods()
  eventListener.setS(() => {setStage(1)});
  setTimeout(() => {
    musicManager.playWarmup();
  }, 50);
}

const prepStage1 = (setMemory) => {
  eventListener.clearMethods();
  setMemory(['A', 'D'])
  eventListener.setA(() => {setMemory(memory => memory.filter(v => v !== 'A'))})
  eventListener.setD(() => {setMemory(memory => memory.filter(v => v !== 'D'))})
}

const prepStage2 = (setStage, setMemory, setScores, setEndTime) => { //change arguments
  const end = Date.now() + PLAYTIME; //new

  setMemory({jumps: 0, situps: 0, startTime: Date.now(), lastUp: Date.now(), lastDown: Date.now() + 1, lastSitup: Date.now(), numUp: 0, numDown: 0})
  eventListener.clearMethods();

  const onTimerFinish = setTimeout(() => {
    console.log("timer done")
    setStage(3)
  }, PLAYTIME)

  eventListener.setS(() => {
    clearTimeout(onTimerFinish)
    setStage(3);
  })
  
  setTimeout(() => {
    musicManager.stopWarmup();
  }, 50);
  
  eventListener.setA_up(() => {
    setMemory(memory => ({...memory, numUp: memory["numUp"] + 1, lastUp: Date.now()}))
  })

  eventListener.setA_down(() => {
    setMemory(memory => {
      const airtime = Date.now() - memory["lastUp"]
      const jumped = (airtime <= 2000) && (50 <= airtime)
      if(jumped) musicManager.playSnare()
      return {...memory, numDown: memory["numDown"] + 1, lastDown: Date.now(), jumps: memory["jumps"] + (jumped ? 1 : 0)}
    })
  })

  eventListener.setD(() => {
    wasSitup(setMemory);
  })
  musicManager.sayText("3 2 1 Go!");
};

const prepStage3 = (setStage, memory, setScores) => {
  eventListener.clearMethods()
  eventListener.setS(() => {setStage(0)})
  musicManager.playTrumpet()
  setTimeout(() => {
    musicManager.sayText(`Times up! You had ${memory["jumps"]} jumps and ${memory["situps"]} situps.`)
  }, 1000)
  setScores(score => [[Date.now(), memory["jumps"], memory["situps"], score.length + 1], ...score].toSorted((a, b) => -(a[1] + a[2] - b[1] - b[2])));
}

export default function Match({ scores, setScores }) {
  // Stage 1, wait for hands to connect before continuing
  const [stage, setStage] = useState(0);
  const [memory, setMemory] = useState(null); // generic state variable
  const [time, setTime] = useState(PLAYTIME / 1000);


  //new
  const [endTime, setEndTime] = useState(null);
  const [remaining, setRemaining] = useState(0);

  useEffect(() => {
    if(stage === 0) {
      prepStage0(setStage);
    } else if(stage === 1) {
      prepStage1(setMemory);
    } else if(stage === 2) {
      prepStage2(setStage, setMemory, setScores, setEndTime)
    } else if(stage === 3) {
      prepStage3(setStage, memory, setScores)
    }
    console.log(stage)
  }, [stage])

  useEffect(() => {
    //new: ensure memory consistent from array to object
    if (memory != null && Array.isArray(memory) && memory.length === 0) {
      setStage((stage) => (stage + 1) % 4);
    }
  }, [memory])

  //===========================================================================
  //NEW: countdown effect while game is running (stage 2)
  useEffect(() => {
    if (stage !== 2 || !('startTime' in memory)) return;
    // initial value
    const id = setInterval(() => {
      const secs = Math.ceil(Math.max(0, PLAYTIME - (Date.now() - memory["startTime"])) / 1000);
      setTime(secs);
      if (secs === 0) {
        clearInterval(id);
      }
    }, 250); // update 4x per second so it feels responsive

    return () => clearInterval(id);
  }, [memory]);


  if(stage === 0) {
    return (<>
      <div className="z-10 text-center">
        <h1 className="font-bold text-2xl">Have a buddy?</h1>
        <h2 className="text-xl">Place your hands on top to get started!</h2>
      </div>
      <div className="-z-99 w-[90%] h-[90%] absolute top-[5%] left-[5%]  rounded-lg animate-pulse block box" />
    </>)
  } else if(stage === 1) {
    return (<div className="text-center relative">
      <h1 className="font-bold text-2xl">Get ready!</h1>
      <h2 className="text-xl w-96">One person should stand on the jump rope pad. The other should sit with their hands on the sit-up spots.</h2>
      {memory != null && Array.isArray(memory) && memory.length === 1 && (
        <div className="absolute -bottom-16 italic w-full text-center animate-pulse">{
        (memory[0] === 'A' ? 
          <p>Waiting for the jump rope pad</p> 
          : <p>Waiting for the sit-up pad</p>)
        }</div>)}
    </div>)
  } else if (stage === 2 && memory !== null && !Array.isArray(memory)) { //new =============
    return (
      <>
        {/* Animation bottom left/right */}
        <div className="absolute bottom-16 left-16 w-[200px] h-[200px]">
          <div key={`${memory["situps"]}`} className="w-[200px] absolute bg-accent top-0 left-0 z-20 ephemeral block">
            <img src={situpUp} />
          </div>
          <div className="w-[200px] absolute top-0 left-0 z-10 block">
            <img src={situpDown} />
          </div>
        </div>

        <div className="absolute bottom-16 right-16 w-[200px] h-[200px]">
          {memory["lastUp"] > memory["lastDown"] && 
          (<div className="w-[200px] absolute top-0 left-0 z-10 block">
            <img src={jumpUp} />
          </div>)}
          {memory["lastUp"] < memory["lastDown"] && 
          (<div className="w-[200px] absolute top-0 left-0 z-10 block">
            <img src={jumpDown} />
          </div>)}
        </div>

        {/* corner frsme flash */}
        <div
          key={`${memory["jumps"]}-${memory["situps"]}`}
          className="absolute w-[95%] h-[95%] top-[2.5%] left-[2.5%] fade-out"
        >
          <div className="w-12 h-12 absolute top-0 left-0 border-t-4 border-l-4 border-white" />
          <div className="w-12 h-12 absolute top-0 right-0 border-t-4 border-r-4 border-white" />
          <div className="w-12 h-12 absolute bottom-0 left-0 border-b-4 border-l-4 border-white" />
          <div className="w-12 h-12 absolute bottom-0 right-0 border-b-4 border-r-4 border-white" />
        </div>

        <div className="flex flex-col items-center justify-center text-center gap-4 w-full">
          <h1 className="font-bold text-2xl">Go!</h1>

          {/* BIG CENTERED COUNTDOWN */}
          <div className="text-7xl md:text-8xl font-mono font-bold tracking-widest">
            {String(time).padStart(2, "0")}
          </div>
          <p className="uppercase text-sm tracking-[0.3em] mt-[-0.5rem]">
            seconds left
          </p>

          {/* stats */}
          <div className="text-xl w-96 flex flex-col gap-2 mt-4">
            <p>{memory["jumps"]} Jumps</p>
            <p>{memory["situps"]} Sit Ups</p>
            {/* <p>{memory["numUp"]}  Ups</p> */}
            {/* <p>{memory["numDown"]} Downs</p> */}
          </div>
        </div>
      </>
    );
  } 
  if (stage === 3) {
    // Sort scores by total
    const sortedScores = scores.toSorted((a, b) => (b[1] + b[2]) - (a[1] + a[2]));
    const topTen = sortedScores.slice(0, 10);

    // Compute current player's rank
    const myRankIndex = sortedScores.findIndex(
      s => s[1] === memory.jumps && s[2] === memory.situps
    );
    const myRank = myRankIndex >= 0 ? myRankIndex + 1 : "-";

    return (
      <div className="flex flex-col items-center justify-center text-center gap-6 w-full mt-8">
        <h1 className="font-bold text-3xl">Congrats!</h1>

        {/* Your session stats */}
        <div className="text-xl w-96 flex flex-col gap-1 mt-2">
          <p><span className="font-semibold">{memory.jumps}</span> Jumps</p>
          <p><span className="font-semibold">{memory.situps}</span> Situps</p>
          <p className="mt-2 italic">Your rank: <span className="font-bold">{myRank}</span></p>
        </div>

        {/* Leaderboard */}
        <div className="text-left w-96 mt-6">
          <h2 className="font-bold items-center justify-center text-center text-xl mb-2">Top 10 Leaderboard</h2>
          <ol className="list-decimal ml-6 space-y-2">
            {topTen.map((s, i) => {
              // Highlight the entry at your rank
              const isMine = i === myRankIndex;
              return (
                <li
                  key={s[0]}
                  className={`flex justify-between ${isMine ? "text-yellow-500 font-bold" : ""}`}
                >
                  <span>#{i + 1} - Jumps: {s[1]}, Situps: {s[2]}</span>
                  <span>Total: {s[1] + s[2]}</span>
                </li>
              );
            })}
          </ol>
        </div>
      </div>
    );
  }



  // Pending
  return <></>
}